export const PERMS = {
    READ: 'service_orders.read',
    UPDATE: 'service_orders.update',
    DELETE: 'service_orders.delete',
    CREATE: 'service_orders.create',
    EXPORT: 'service_orders.export',
}